import { render } from "./pageContainer.vue?vue&type=template&id=677179ea"
import script from "./pageContainer.vue?vue&type=script&lang=js"
export * from "./pageContainer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__